module.exports = __webpack_public_path__ + "img/priceTagDown.cb429716.png";